<template>
  <div>
    <!-- filter -->
    <prewarn-filter ref="queryFormRef" placeholder="请输入规则ID或者名称" @change="getData">
      <el-button type="primary" @click="$router.push({ name: 'prewarnadd' })">新建预警规则</el-button>
    </prewarn-filter>
    <!-- table -->
    <Viewport v-model="tableHeight" v-loading="tableLoading">
      <prewarn-table :height="tableHeight" :data="tableList" :columns="tableCol" @on-refresh="getData" />
      <div class="pager">
        <el-pagination
          class="pager"
          background
          layout="sizes, prev, pager, next, total"
          :page-size.sync="pageSize"
          :current-page.sync="pageIndex"
          :total="total"
          @current-change="changePageIndex"
          @size-change="changePageSize"
        >
        </el-pagination>
      </div>
    </Viewport>
  </div>
</template>
<script>
import columns from '../data/prewarn_column'
import { setLocal, getLocal, div } from '@/common/js/api'
import { isArray } from '@/common/js/utils'
import { getPreWarnList } from '@/api/manage.model'
import PrewarnFilter from './components/prewarn-filter.vue'
import PrewarnTable from './components/prewarn-table.vue'
export default {
  name: 'monitor',
  components: { PrewarnFilter, PrewarnTable },
  data() {
    return {
      pageIndex: 1,
      pageSize: 20,
      total: 0,
      tableCol: [],
      tableList: [],
      tableLoading: false,
      tableHeight: 400
    }
  },
  methods: {
    changePageIndex(index) {
      this.pageIndex = index
      this.getData()
    },
    changePageSize(size) {
      this.pageSize = size
      this.changePageIndex(1)
    },
    getData() {
      const form = this.$refs.queryFormRef.buildParams()

      const params = {
        ...form,
        page: this.pageIndex,
        pageSize: this.pageSize
      }

      this.tableLoading = true
      getPreWarnList(params)
        .then((data) => {
          if (!data) return
          const { list, page_info } = data
          if (isArray(list) && page_info) {
            const { total_number } = page_info
            this.total = total_number || 0
            this.tableList = list.map((ret) => {
              if (ret.ruleDesc) ret.ruleDesc = ret.ruleDesc.split(';')
              else ret.ruleDesc = []
              return ret
            })
          }
        })
        .catch((err) => {
          this.$Message.error({
            duration: 5,
            content: err
          })
        })
        .finally(() => {
          this.tableLoading = false
        })
    },
    setLocalPage(size) {
      setLocal('MONITOR_PAGESIZE', size)
    }
  },
  created() {
    this.pageSize = parseInt(getLocal('MONITOR_PAGESIZE')) || 20
    this.tableCol = columns
    this.sort = 'create_time'
    this.order = 'desc'

    this.$nextTick(() => {
      this.getData()
    })
  },

  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (['prewarnedit', 'prewarnadd'].includes(from.name)) {
        vm.getData()
      }
    })
  }
}
</script>
<style lang="scss" scoped>
.pager {
  text-align: right;
}

.c-table-page {
  padding: 0 8px;
  margin-top: 8px;
  text-align: right;
}
</style>
